import { Cabin, GetOffersV2Response, TransportType, UpgradeProduct, UpgradeStatus, VoucherType } from '../api/models';

export const DE23FG: GetOffersV2Response = {
  booking: {
    passengers: [
      {
        passengerId: 'MSAINOPEKKANEN',
        firstName: 'AINO',
        lastName: 'PEKKANEN',
        title: 'MS',
        type: 'ADT',
        child: null,
        firstNameWithTitle: 'AINO MS',
        ordinal: 1,
      },
      {
        passengerId: 'MRPEKKAPEKKANEN',
        firstName: 'PEKKA',
        lastName: 'PEKKANEN',
        title: 'MR',
        type: 'ADT',
        child: null,
        firstNameWithTitle: 'PEKKA MR',
        ordinal: 2,
      },
      {
        passengerId: 'MRREINOPEKKANEN',
        firstName: 'REINO',
        lastName: 'PEKKANEN',
        title: 'MR',
        type: 'ADT',
        child: null,
        firstNameWithTitle: 'REIJO MR',
        ordinal: 3,
      },
    ],
    flights: [
      {
        segmentInfo: {
          flightId: 'AY-456-OUL-HEL-2023-02-09T19:30:00',
          group: 1,
          ordinal: 1,
          carrierCode: 'AY',
          flightNumber: '456',
          boardPoint: 'OUL',
          offPoint: 'HEL',
          departureDateTimeLocal: '2023-02-09T19:30:00',
          departureDateTime: '2023-02-09T19:30:00.000+02:00',
          arrivalDateTimeLocal: '2023-02-09T20:35:00',
          arrivalDateTime: '2023-02-09T20:35:00.000+02:00',
          durationInMinutes: 65,
          longHaul: false,
          cabin: Cabin.Economy,
          travelClass: 'O',
          transportType: TransportType.Flight,
          segmentTattoo: '1',
        },
        upgrades: [
          {
            upgradeProductName: UpgradeProduct.EconomyToBusiness,
            isWaitlist: false,
            seatsAvailable: 0,
            travelClass: 'U',
            paymentOptions: {},
            upgradeStatus: UpgradeStatus.NotAvailable,
          },
        ],
      },
      {
        segmentInfo: {
          flightId: 'AY-131-HEL-SIN-2023-02-09T23:40:00',
          group: 1,
          ordinal: 2,
          carrierCode: 'AY',
          flightNumber: '131',
          boardPoint: 'HEL',
          offPoint: 'SIN',
          departureDateTimeLocal: '2023-02-09T23:40:00',
          departureDateTime: '2023-02-09T23:40:00.000+02:00',
          arrivalDateTimeLocal: '2023-02-10T18:15:00',
          arrivalDateTime: '2023-02-10T18:15:00.000+08:00',
          durationInMinutes: 755,
          longHaul: true,
          cabin: Cabin.Economy,
          travelClass: 'O',
          transportType: TransportType.Flight,
          segmentTattoo: '2',
        },
        upgrades: [
          {
            upgradeProductName: UpgradeProduct.EconomyToBusiness,
            isWaitlist: false,
            seatsAvailable: 3,
            travelClass: 'U',
            paymentOptions: {
              money: {
                price: '627',
                currency: 'EUR',
              },
              points: {
                price: 50000,
              },
              LONG_HAUL_UPGRADE: {
                price: 1,
              },
              UPGRADE_BENEFIT: {
                price: 4,
              },
            },
            upgradeStatus: UpgradeStatus.Available,
          },
          {
            upgradeProductName: UpgradeProduct.EconomyToPremiumeconomy,
            isWaitlist: false,
            seatsAvailable: 2,
            travelClass: 'F',
            paymentOptions: {
              money: {
                price: '251',
                currency: 'EUR',
              },
              points: {
                price: 20000,
              },
              UPGRADE_BENEFIT: {
                price: 2,
              },
            },
            upgradeStatus: UpgradeStatus.Available,
          },
        ],
      },
      {
        segmentInfo: {
          flightId: 'AY-132-SIN-HEL-2023-02-23T22:30:00',
          group: 2,
          ordinal: 1,
          carrierCode: 'AY',
          flightNumber: '132',
          boardPoint: 'SIN',
          offPoint: 'HEL',
          departureDateTimeLocal: '2023-02-23T22:30:00',
          departureDateTime: '2023-02-23T22:30:00.000+08:00',
          arrivalDateTimeLocal: '2023-02-24T06:10:00',
          arrivalDateTime: '2023-02-24T06:10:00.000+02:00',
          durationInMinutes: 820,
          longHaul: true,
          cabin: Cabin.Economy,
          travelClass: 'V',
          transportType: TransportType.Flight,
          segmentTattoo: '3',
        },
        upgrades: [
          {
            upgradeProductName: UpgradeProduct.EconomyToBusiness,
            isWaitlist: true,
            seatsAvailable: 0,
            travelClass: 'U',
            paymentOptions: {
              points: {
                price: 50000,
              },
              LONG_HAUL_UPGRADE: {
                price: 1,
              },
              UPGRADE_BENEFIT: {
                price: 4,
              },
            },
            upgradeStatus: UpgradeStatus.Available,
          },
          {
            upgradeProductName: UpgradeProduct.EconomyToPremiumeconomy,
            isWaitlist: false,
            seatsAvailable: 2,
            travelClass: 'F',
            paymentOptions: {
              money: {
                price: '312',
                currency: 'EUR',
              },
              points: {
                price: 20000,
              },
              UPGRADE_BENEFIT: {
                price: 2,
              },
            },
            upgradeStatus: UpgradeStatus.Available,
          },
        ],
      },
      {
        segmentInfo: {
          flightId: 'AY-433-HEL-OUL-2023-02-24T07:30:00',
          group: 2,
          ordinal: 2,
          carrierCode: 'AY',
          flightNumber: '433',
          boardPoint: 'HEL',
          offPoint: 'OUL',
          departureDateTimeLocal: '2023-02-24T07:30:00',
          departureDateTime: '2023-02-24T07:30:00.000+02:00',
          arrivalDateTimeLocal: '2023-02-24T08:45:00',
          arrivalDateTime: '2023-02-24T08:45:00.000+02:00',
          durationInMinutes: 75,
          longHaul: false,
          cabin: Cabin.Economy,
          travelClass: 'V',
          transportType: TransportType.Flight,
          segmentTattoo: '4',
        },
        upgrades: [
          {
            upgradeProductName: UpgradeProduct.EconomyToBusiness,
            isWaitlist: false,
            seatsAvailable: 0,
            travelClass: 'U',
            paymentOptions: {},
            upgradeStatus: UpgradeStatus.NotAvailable,
          },
        ],
      },
    ],
  },
  buyer: {
    email: 'SAM.WARREN@FINNAIR.COM',
    points: 32675696,
    vouchers: [
      {
        type: VoucherType.EuropeUpgrade,
        count: 9,
      },
      {
        type: VoucherType.LongHaulUpgrade,
        count: 2,
      },
      {
        type: VoucherType.UpgradeBenefit,
        count: 4,
      },
    ],
  },
};
